/**
 * sms: URI to open the device messaging app with START pre-filled.
 */
export default function buildCarrierStartSmsUri(organizationPhoneNumber) {
  const phone = (organizationPhoneNumber || '').trim();
  if (!phone) {
    return '';
  }
  return `sms:${phone}?body=${encodeURIComponent('START')}`;
}
